import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Amplify, { Analytics } from 'aws-amplify';
import { withAlert } from 'react-alert';
import { Link } from 'react-router-dom';
import ReactTable from 'react-table';
import * as SecretKeys from '../../../ENV.json';
import { submitSubUser, getAllAffiliatedUsers, deleteAffiliatedSubUser } from '../../../Actions/actions';
import 'react-table/react-table.css';

Amplify.configure(SecretKeys.awsUserpool);

Analytics.disable();

class SubuserListAffiliate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      firstname: '',
      lastname: '',
      phone: '',
      password: '',
      errors: {},
      isLoading: false,
      isDelete: false,
      failedLoginMessages: '',
      data: [],
    };
    this.onChange = this.onChange.bind(this);
    this.handleSubUsers = this.handleSubUsers.bind(this);
  }

  onChange(e) {
    this.setState({ errors: {}, isLoading: true, failedLoginMessages: '' });
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSubUsers(e) {
    e.preventDefault();
    this.props.submitSubUser(this.state);
  }

  componentDidMount() {
    this.props.getAllAffiliatedUsers();
  }

  handleClickOpenDelete(Id, value) {
    const data = {
      id: Id,
      value: value
    };
    this.setState({ isDelete: true });
    this.props.deleteAffiliatedSubUser(data);
  }

  componentWillReceiveProps() {
    // console.log(settleRecord);
    if (this.state.isDelete) {
      this.props.getAllAffiliatedUsers();
      this.setState({ isDelete: false });
    }

    // this.setState({data: settleRecord.result});
  }

  render() {
    const { data } = this.state;

    return (
      <span>
        <div className="section-content partner-dashboard partner-referral">
          <div className="row">
            <div className="col s12">
              <div className="">
                <div className="col s12">
                  <div className="col s12 referral-hdr">
                    <h4 className="col s12 m9">Manage Sub Users</h4>
                    <div className="col s12 m3 grid-add-link">
                      <Link to="/addSubUsers">Add</Link>
                    </div>
                  </div>
                  <div className="referral-data">
                    <div className="col s12">
                      <ReactTable
                        data={data}
                        columns={[
                          {
                            columns: [
                              {
                                Header: 'ID',
                                accessor: 'affiliateSubUserId',
                              }, {
                                Header: 'First Name',
                                accessor: 'firstName',
                              },
                              {
                                Header: 'Last Name',
                                id: 'lastName',
                                accessor: d => d.lastName,
                              }, {
                                Header: 'Email',
                                id: 'email',
                                accessor: d => d.email,
                                filterable: false,
                              }, {
                                Header: 'Phone',
                                id: 'phone',
                                accessor: d => d.phoneNumber,
                              },
                              {
                                Header: 'Actions',
                                id: 'link',
                                filterable: false,
                                accessor: d => d, // https://github.com/Michaelcj10/ReactJS-GitHub-User-Finder-App
                                Cell: props => (
                                  <div>
                                    <a herf="#" onClick={() => this.handleClickOpenDelete(props.value.affiliateSubUserId, props.value)}>
                                      <i className="small material-icons">delete_forever</i>
                                    </a>
                                    <Link
                                      className="font-medium show-right-button"
                                      to={`/affiliate/update/${props.value.affiliateSubUserId}`}
                                    >
                                      <i className="small material-icons">create</i>
                                    </Link>
                                    {/* <Link className="font-medium show-right-button"
to={`/consumer/view/${props.value}`}><Icon>visibility</Icon>
</Link> */}

                                  </div>
                                ),
                              },
                            ],
                          },
                        ]}
                        defaultPageSize={10}
                        className="-striped -highlight"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </span>
    );
  }
}

SubuserListAffiliate.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators({ submitSubUser, getAllAffiliatedUsers, deleteAffiliatedSubUser }, dispatch);

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(SubuserListAffiliate));
